// extracted by mini-css-extract-plugin
export var alertIcon = "_tw-0";